import { ObjectSelectInput, ObjectSelectProps } from '@frontend/components/basic-forms';
import { TransactionClient } from '@frontend/transaction/api';
import { Transaction, TransactionQueryParams } from '@frontend/transaction/types';
import React, { useState } from 'react';

const ID = 'transaction-select';
export const TransactionSelectV2 = (props: ObjectSelectProps<Transaction, TransactionQueryParams> ) => {
    const [v, cV] = useState<Transaction | null>(null);
    return (
        <ObjectSelectInput<Transaction, TransactionQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label='Transaction'
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={props.queryParams}
            value={v}
            idValue={props.value || v?.id}
            fetch={(props) => TransactionClient.fetchTransactions(props)}
            itemLabel={(transaction) => transaction.tracking_number ?? transaction.id}
            isClearable={props.isClearable}
            useQueryParam={
                props.allowURLChange
                    ? {
                          param: 'transaction_id',
                          fetch: (id) =>
                              TransactionClient.resolveTransactions([id]).then((res) => {
                                  return res.results[0];
                              })
                      }
                    : undefined
            }
        />
    );
};
